/** `myAwpResults` / `myAwpDownloadUrl` data-access layer: the member's approved AWP documents. */

import type { AwpDocument } from '@mdvip/shared/features/awp-documents/types';
import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { MyAwpDownloadUrlDocument, MyAwpResultsDocument, type MyAwpResultsQuery } from '@/graphql/generated/graphql';

/** Under the same `['awp']` prefix as the AWP dashboard's keys, so invalidating every AWP query includes this list. */
export const awpDocumentsKey = ['awp', 'myAwpResults'] as const;

/** Approved, not-deleted visits, newest first: the server filters and orders, so nothing is re-sorted here. */
export function requestMyAwpResults(): Promise<MyAwpResultsQuery> {
  return gqlRequest(MyAwpResultsDocument);
}

export function mapToAwpDocument(row: MyAwpResultsQuery['myAwpResults'][number]): AwpDocument {
  return { id: row.id, phrId: row.phrId, examDate: row.examDate };
}

/**
 * A short-lived pre-signed URL for one document's PDF. It is a bearer credential, so it goes straight
 * to the caller and never into the query cache.
 */
export async function requestMyAwpDownloadUrl(doc: AwpDocument): Promise<string> {
  const data = await gqlRequest(MyAwpDownloadUrlDocument, { phrId: doc.phrId });
  return data.myAwpDownloadUrl.url;
}
